import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IRoles } from 'src/app/interfaces/roles';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }
  
  constructor(
    private http: HttpClient
  ) { }

  getRoles(): Observable<IRoles> {
    const url = `${environment.endpointAdministrativo}/v1/accesos/obtener-roles`
    return this.http.get<IRoles>(url, { headers: this.getHeaders() })
  }
  
  obtenerMenus(id: number | undefined):Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/accesos/obtener-menus?rol-id=${id}`;
    return this.http.get<any>(url, { headers: this.getHeaders() });
  }
  
  postRoles(body: any): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/accesos/guardar`;
    return this.http.post(url, body, { headers: this.getHeaders() });
  }
}
